export enum ShareNet {
	Facebook = "fb",
	Twitter = "tw",
}

export enum ShareSource {
	General = "general",
}

export enum RequestState {
	IDLE,
	Requested,
	Received,
	Error,
}

export enum RequestStateType {
	Loading,
	Success,
	Error,
	Idle,
}

export enum SaveButtonType {
	Disabled,
	Saving,
	Saved,
	Enabled,
}

export enum PrivacyType {
	Private = "private",
	Public = "public",
}

export enum LanguageType {
	DE = "de",
	EN = "en",
	ES = "es",
	FR = "fr",
	AR = "ar",
}

export enum StatusType {
	Active = "active",
	Complete = "complete",
	Scheduled = "scheduled",
}

export enum ViewPortVisibility {
	MobileOnly = "MobileOnly",
	DesktopOnly = "DesktopOnly",
}

export enum LinkType {
	Internal = "internal",
	External = "external",
}

export enum ProjectName {
	Brackets = "CONTENT_BRACKET",
	Predictor = "DRAW_PREDICTOR",
	Trivia = "TRIVIA",
	GameZone = "GAME_ZONE",
}
